import React from 'react';

// eslint-disable-next-line no-restricted-imports
import { DatePicker } from 'antd';
import { Moment } from 'moment';

const { RangePicker } = DatePicker;

const DEFAULT_FORMAT = 'YYYY-MM-DD';

interface Props<T> {
	onChange: (dates: T[], dateStrings: [string, string]) => void;
	defaultValue?: [T, T];
	format?: string | string[];
}

const RangeCalendar: React.FunctionComponent<Props<Moment>> = props => {
	const { onChange, defaultValue, format = DEFAULT_FORMAT } = props;

	return (
		<RangePicker
			showTime={false}
			format={format}
			onChange={onChange}
			defaultValue={defaultValue}
			allowClear={false}
		/>
	);
};

export default RangeCalendar;
